import { useEffect, useState } from 'react';
import { useAppointment } from '../../context/appointmentContext';
import { useNavigate, useParams } from 'react-router-dom';
import { ResponsiveLoadingPage } from '.';
import { usePostMessage, useReceiveMessage } from '../../context/messageContext';
import { useResultData } from '../../helpers/useResultData';
import { ClinicianLobby, PatientLobby } from '../session/Lobby';

const ResponsiveWelcome = () => {
  let navigate = useNavigate();
  const [opticianView, setOpticianView] = useState(null);
  const { appointment } = useAppointment();
  const params = useParams();
  const postMessage = usePostMessage();
  const receivedMessage = useReceiveMessage();
  const { clearAllResults } = useResultData();

  useEffect(() => {
    clearAllResults();
  }, [clearAllResults]);

  useEffect(() => {
    if (appointment?.currentUser?.role !== 'patient') return;

    const requestScreenWakeLock = async () => {
      try {
        await navigator.wakeLock.request('screen');
      } catch (err) {
        console.error(err);
      }
    };

    requestScreenWakeLock();
  }, [appointment?.currentUser?.role]);

  useEffect(() => {
    // check room_name in url, if different from room_name in local storage, update local storage
    const roomName = localStorage.getItem('room_name') || null;
    const newRoomName = params?.roomName || null;

    if (newRoomName !== roomName && newRoomName !== null) {
      localStorage.setItem('room_name', newRoomName);
    }
  }, [appointment]); // when the context appointment state changes, it fires the useEffect

  useEffect(() => {
    //set user role
    if (appointment?.currentUser?.role !== 'patient') {
      setOpticianView(true);
    } else setOpticianView(false);
  }, [appointment?.currentUser?.role]);

  useEffect(() => {
    //handle patient navigation
    if (receivedMessage && !opticianView) {
      switch (receivedMessage?.type) {
        case 'heartBeat':
          return postMessage({ type: 'heartBeatResponse', room_name: receivedMessage.room_name });
        case 'opticianLoggedOut':
          return navigate(`${process.env.PUBLIC_URL}/error`, {
            state: { error: 'This session has been closed. Close your browser to end the appointment.', title: 'Session closed' },
          });
        case 'heartBeatResponse':
        case 'navigateToWelcomeScreen':
        case 'welcomeScreen':
        case 'initialisationComplete':
        case 'synchroniseTestData':
          break;
        default:
          return navigate(`${process.env.PUBLIC_URL}/patient`);
      }
    }
  }, [receivedMessage, postMessage, opticianView, navigate]);

  useEffect(() => {
    if (!appointment) return;
    return postMessage({ type: 'welcomeScreen', senderRole: appointment?.currentUser?.role !== 'patient' ? 'clinician' : 'patient' });
  }, [postMessage, appointment]);

  // P1 (patient) / C1 (clinician) lobby in the IBISengage design. Navigation logic above is unchanged.
  if (!appointment) return <ResponsiveLoadingPage />;
  return opticianView ? <ClinicianLobby /> : <PatientLobby />;
};

export default ResponsiveWelcome;
